import { render } from "./LifeOnFireVideo.vue?vue&type=template&id=3187ff54&scoped=true"
import script from "./LifeOnFireVideo.vue?vue&type=script&lang=js"
export * from "./LifeOnFireVideo.vue?vue&type=script&lang=js"

import "./LifeOnFireVideo.vue?vue&type=style&index=0&id=3187ff54&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3187ff54"]])

export default __exports__